import { ReactNode } from 'react';

interface KpiProps {
    label: string;
    value: ReactNode;
    /** Aclaración corta debajo del valor. */
    hint?: string;
}

/**
 * Indicador (design system §3.6): el valor va en --text-strong, sin color de estado.
 * Va dentro de un `.md-kpi-row`. Estilos en src/scss/_design-system.scss.
 */
export default function Kpi({ label, value, hint }: KpiProps) {
    return (
        <div className="md-kpi">
            <span className="md-kpi__label">{label}</span>
            <span className="md-kpi__value">{value}</span>
            {hint && <span className="md-kpi__hint">{hint}</span>}
        </div>
    );
}
